import React, { useEffect, useState } from "react";
import HeroSlider from "../components/HeroSlider";
import HomeAboutContact from "../components/HomeAboutContact";
import { ProgramCard, VideoCard, LiveCard, RowHeader } from "../components/Cards";
import VideoModal from "../components/VideoModal";
import LivePlayerModal from "../components/LivePlayerModal";
import {
  getHeroSlides, getPrograms, getVideos,
} from "../lib/api";
import { HERO_SLIDE_IMAGES, HERO_SLIDE_COUNT } from "../constants/assets";
import { useLiveStreamsPoll } from "../hooks/useLiveViewers";

const DEFAULT_HERO_SLIDES = [
  {
    id: "hero-1",
    title: "Doğru Bilgi, Güçlü Yayın.",
    highlight: "Güvenilir Platform.",
    subtitle: "Gündemi yakından takip ediyor, nitelikli içeriklerimizle hayata dair değer katıyoruz.",
    image: HERO_SLIDE_IMAGES[0],
    order: 1,
  },
  {
    id: "hero-2",
    title: "Her An, Her Yerde.",
    highlight: "Kesintisiz Yayın.",
    subtitle: "Canlı yayınlarımız ve program arşivimizle içeriğe her zaman ulaşın.",
    image: HERO_SLIDE_IMAGES[1],
    order: 2,
  },
  {
    id: "hero-3",
    title: "İnsana Dair.",
    highlight: "Ne Varsa.",
    subtitle: "Haberden spora, kültürden sanata hayatın her alanında yanınızdayız.",
    image: HERO_SLIDE_IMAGES[2],
    order: 3,
  },
];

function normalizeHeroSlides(data) {
  if (!data.length) return DEFAULT_HERO_SLIDES;

  return data
    .slice(0, HERO_SLIDE_COUNT)
    .map((slide, i) => ({ ...slide, image: HERO_SLIDE_IMAGES[i] }));
}

export default function Home() {
  const [slides, setSlides] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [videos, setVideos] = useState([]);
  const { streams: lives } = useLiveStreamsPoll();
  const [activeVideo, setActiveVideo] = useState(null);
  const [activeLive, setActiveLive] = useState(null);

  useEffect(() => {
    getHeroSlides()
      .then((data) => setSlides(normalizeHeroSlides(data)))
      .catch(() => setSlides(DEFAULT_HERO_SLIDES));
    getPrograms().then(setPrograms).catch(() => {});
    getVideos().then(setVideos).catch(() => {});
  }, []);

  return (
    <div>
      <HeroSlider slides={slides} />

      <div className="tv-container mt-16 space-y-20">
        <section className="tv-scroll-section">
          <RowHeader title="Programlarımız" to="/programlar" linkLabel="Tüm Programlar →" />
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {programs.slice(0, 5).map((p, i) => (
              <ProgramCard key={p.id} program={p} index={i} />
            ))}
          </div>
        </section>

        <section className="tv-scroll-section">
          <RowHeader title="Program Videoları" to="/videolar" linkLabel="Tüm Videolar →" />
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {videos.slice(0, 5).map((v, i) => (
              <VideoCard key={v.id} video={v} index={i} onPlay={setActiveVideo} />
            ))}
          </div>
        </section>

        <section className="tv-scroll-section">
          <RowHeader title="Canlı Yayınlar" to="/canli-yayin" linkLabel="Tüm Canlı Yayınlar →" />
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {lives.slice(0, 5).map((s, i) => (
              <LiveCard key={s.id} stream={s} index={i} onOpen={setActiveLive} />
            ))}
          </div>
        </section>

        <HomeAboutContact />
      </div>

      <VideoModal open={!!activeVideo} video={activeVideo} onClose={() => setActiveVideo(null)} />
      <LivePlayerModal open={!!activeLive} stream={activeLive} onClose={() => setActiveLive(null)} />
    </div>
  );
}
